import { PACKAGE_KEY } from "./advancepayPackage";

const FIRST3 = {
  productKey: PACKAGE_KEY.PRIME[289].S1,
  goiProductName: "고이 퍼스트3",
  mainService: "가족장289",
  defaultText: "딱 한 번 3만원 결제하고\n차액은 장례 후 납부하기",
  benefitText: ``,
  productMemo: "",
};

const FIRST10 = {
  productKey: PACKAGE_KEY.PAYBK[289].V11,
  goiProductName: "고이 퍼스트10",
  mainService: "가족장289",
  defaultText: "딱 한 번 10만원 결제하고\n차액은 장례 후 납부하기",
  benefitText: `10만원 추가 할인\n최종 혜택가 2,790,000원`,
  productMemo: "2025/07/20 할인액 조정",
};

/** 기록용 상품 */
const FIRST30 = {
  productKey: "TW25PMGV2",
  goiProductName: "고이 퍼스트30",
  mainService: "가족장279",
  defaultText: "딱 한 번 30만원 결제하고\n차액은 장례 후 납부하기",
  benefitText: `최소 36만원할인(이용년도 기준)`,
  productMemo: "",
};

const FIRST30I = {
  productKey: "TW25PMIV2",
  mainService: "일반장379",
  defaultText: "딱 한 번 30만원 결제하고\n차액은 장례 후 납부하기",
  benefitText: `최소 36만원할인(이용년도 기준)`,
  productMemo: "",
};

export const AVAILABLE_PACKAGES = {
  FIRST3,
  FIRST10,
};

export const UNAVAILABLE_PACKAGES = {
  FIRST30,
  FIRST30I,
};
